import TopSection from "../../LT/TopSection";
import React, { useState, useEffect } from "react";
import {
    Box,
    TextField,
    Typography,
    MenuItem,
    Select,
    Stack,
    Card,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import ButtonComponent from "../../../components/common/button/Button";
import { getSupplierDropdownList } from "../../../redux/actions/SupplierDropdownListSlice";
import { getSupplierDropdownListEndpoint, postAnnouncementEndpoint, viewAllAnnouncementEndpoint, viewParticularAnnouncementEndpoint } from "../../../common/endpoints";
import { MultiDropdown } from "../../../components/common/MultiDropdown";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import { NewGroupedMultiDropdown } from "../SupplierManagement/NewGroupedMultiDropdown";
import { GroupedSupplierDropdown } from "../SupplierManagement/GroupedSupplierDropdown";
import { postAnnouncementSlice } from "../../../redux/actions/postAnnouncementSlice";
import { getViewParticularAnnouncementSlice } from "../../../redux/actions/GetViewParticularAnnouncementSlice";
import { getViewAllAnnouncementSlice } from "../../../redux/actions/GetViewAllAnnouncementSlice";

const thStyle = {
    padding: "10px",
    fontWeight: 600,
    fontSize: "14px",
};

const tdStyle = {
    padding: "10px",
    fontSize: "14px",
};

const viewFieldStyle = {
    "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "#000 !important",
        cursor: "not-allowed",
    },
    "& .MuiOutlinedInput-root.Mui-disabled": {
        backgroundColor: "#f5f5f5",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#d1d5db !important",
    },
};

const AdminAnnouncements = () => {
    const dispatch = useDispatch();
    const [type, setType] = useState("General");
    const [editId, setEditId] = useState(null);
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [parentVendor, setParentVendor] = useState("");
    const [childVendor, setChildVendor] = useState("");
    const [announcements, setAnnouncements] = useState([]);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [fileInputKey, setFileInputKey] = useState(Date.now());
    const [apiSupplierListData, setApiSupplierListData] = useState([]);
    const [plantsDropdownOptions, setPlantsDropdownOptions] = useState([]);
    const [selectedParents, setSelectedParents] = useState([]);
    const [selectedChildren, setSelectedChildren] = useState([]);
    const [filterSuppliers, setFilterSuppliers] = useState([]);
    const [selectedPlants, setSelectedPlants] = useState([]);


    const [errors, setErrors] = useState({
        title: "",
        content: ""
    });

    const userName = localStorage.getItem("userName");
    const loading = useSelector(
        (state) => state.postAnnouncementSlice?.loading
    );
    const isSupplierSpecific = type === "Supplier Specific";
    const isPlannerSpecific = type === "Plant Specific";

    useEffect(() => {
        getSupplierList();
    }, [])

    useEffect(() => {
        fetchAnnouncements();
    }, []);

    const handleSubmit = async () => {
        let newErrors = {};

        if (!title.trim()) newErrors.title = "Title is required";
        if (!content.trim()) newErrors.content = "Content is required";

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        try {

            const loggedInUserEmail = localStorage.getItem("userEmail");

            // API TYPE MAPPING
            let announcementType = "GENERAL";

            if (type === "Supplier Specific") {
                announcementType = "SUPPLIER_SPECIFIC";
            }
            else if (type === "Plant Specific") {
                announcementType = "PLANT_SPECIFIC";
            }

            // SUPPLIER DETAILS
            let supplierDetails = [];

            // SUPPLIER SPECIFIC
            if (type === "Supplier Specific") {

                supplierDetails = selectedParents.map((parent) => ({
                    parentId: parent.parentId,
                    parentName: parent.parentName,

                    childSuppliers: selectedChildren
                        .filter(
                            (child) =>
                                child.parentId === parent.parentId
                        )
                        .map((child) => ({
                            supplierId: child.supplierId,
                            supplierName: child.supplierName,
                        })),
                }));
            }

            // PLANT SPECIFIC
            if (type === "Plant Specific") {

                supplierDetails = [
                    {
                        childSuppliers: [
                            {
                                plants: (selectedPlants || []).map((pl) => ({
                                    plant: pl.value,
                                    plantName: pl.title
                                        ?.split(" | ")
                                        ?.slice(1)
                                        .join(" | ")
                                        ?.trim(),
                                })),
                            },
                        ],
                    },
                ];
            }
            // REQUEST BODY
            const requestBody = {
                announcementType,
                title,
                content,
                supplier_details: supplierDetails,
            };
            console.log(requestBody)

            // FORM DATA
            const formData = new FormData();

            const blob = new Blob([JSON.stringify(requestBody)], {
                type: "application/json",
            });

            formData.append("request", blob);

            // OPTIONAL FILE
            if (uploadedFile) {
                formData.append("file", uploadedFile);
            }

            // API CALL
            const response = await dispatch(
                postAnnouncementSlice({
                    dynamicEndpoint: `${postAnnouncementEndpoint}/${loggedInUserEmail}`,
                    data: formData,
                })
            );

            // SUCCESS
            if (response?.meta?.requestStatus === "fulfilled") {

                toast.success("Announcement published successfully", {
                    autoClose: 2000,
                });
                fetchAnnouncements();
                // RESET
                setTitle("");
                setContent("");
                setType("General");
                setEditId(null);
                setUploadedFile(null);
                setSelectedParents([]);
                setSelectedChildren([]);
                setSelectedPlants([]);
                setErrors({});
                setFileInputKey(Date.now());

            } else {

                toast.error(
                    response?.payload?.errorMessage ||
                    "Failed to publish announcement",
                    {
                        autoClose: 2000,
                    }
                );
            }

        } catch (error) {

            console.error("API error:", error);

            toast.error("Something went wrong", {
                autoClose: 2000,
            });
        }
    };


    // const handleDelete = (id) => {
    //     setAnnouncements((prev) => prev.filter((item) => item.id !== id));
    // };

    // const handleEdit = (item) => {
    //     setTitle(item.title);
    //     setContent(item.content);
    //     setType(item.type)
    //     setEditId(item.id); // ⭐ important
    //     // you can also store id if you want update logic later
    // };

    const handleView = async (announcementId) => {
        const loggedInUserEmail = localStorage.getItem("userEmail");

        const response = await dispatch(
            getViewParticularAnnouncementSlice({
                dynamicEndpoint: `${viewParticularAnnouncementEndpoint}/${loggedInUserEmail}/${announcementId}`,
            })
        );

        if (response?.meta?.requestStatus === "fulfilled") {
            setViewData(response.payload);
            setOpenViewPopup(true);
        } else {
            toast.error("Failed to fetch announcement details");
        }
    };

    const getSupplierList = async () => {
        const loggedInUserEmail = localStorage.getItem("userEmail");

        try {
            const response = await dispatch(
                getSupplierDropdownList({
                    dynamicEndpoint: getSupplierDropdownListEndpoint,
                    params: { userEmail: loggedInUserEmail }
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {

                const payload = response?.payload || {};

                const parentChildList =
                    payload?.parentChildSupplierDetailsList || [];

                setApiSupplierListData(
                    parentChildList.map((p) => ({
                        parentId: p.parentId,
                        parentName: p.parentName,
                        childSuppliers: p.childSuppliers || []
                    }))
                );

                // Plants dropdown
                const plants = parentChildList.flatMap((p) =>
                    (p.childSuppliers || []).flatMap((c) =>
                        (c.plants || [])
                            .filter(pl => pl?.plant) // keep only valid
                            .map((pl) => {
                                const plant = pl?.plant?.trim();
                                const plantName = pl?.plantName?.trim();

                                if (!plant) return null;

                                return {
                                    title: `${plant} | ${plantName || ""}`,
                                    value: plant
                                };
                            })
                    )
                ).filter(Boolean);

                // remove duplicates
                const uniquePlants = Array.from(
                    new Map(plants.map(item => [item.value, item])).values()
                );
                setPlantsDropdownOptions(uniquePlants);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const fetchAnnouncements = async () => {
        const loggedInUserEmail = localStorage.getItem("userEmail");

        try {
            const response = await dispatch(
                getViewAllAnnouncementSlice({
                    dynamicEndpoint: `${viewAllAnnouncementEndpoint}/${loggedInUserEmail}`,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {
                setAnnouncements(response.payload || []);
            } else {
                toast.error("Failed to load announcements");
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        }
    };

    const handleParentVendorChange = (items) => {

        setSelectedParents(items || []);
        setSelectedChildren([]);

        const flattenedChildSuppliers = (items || []).flatMap((parent) =>
            (parent.childSuppliers || []).map((child) => ({
                supplierId: child.supplierId,
                supplierName: child.supplierName,
                parentId: parent.parentId,
                parentName: parent.parentName,
                plants: child.plants || [],
                label: `${child.supplierId} | ${child.supplierName}`,
                value: child.supplierId,
            }))
        );
        setFilterSuppliers(flattenedChildSuppliers); // missing


    };

    const handleChildVendorChange = (items) => {
        setSelectedChildren(items || []);
        console.log(items)
        // optionally reset plants when child changes

    };

    const parentOptions = (apiSupplierListData || []).map((p) => ({
        label: `${p.parentId} | ${p.parentName}`,
        value: p.parentId,
        ...p
    }));

    const getUniquePlants = (data = []) => {
        const map = new Map();

        data.forEach((p) => {
            if (!map.has(p.plant)) {
                map.set(p.plant, {
                    label: `${p.plant} | ${p.plantName}`,
                    value: p.plant
                });
            }
        });

        return Array.from(map.values());
    };

    return (
        <>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "Announcements" },
                ]}
                headerName="Announcements Management"
                hideHeader
            />
            <div style={{ paddingBottom: 10, padding: 8 }}>
                <Card
                    sx={{
                        backgroundColor: "#f9fafb",
                        borderRadius: 2,
                        boxShadow: 1,
                        p: 2,
                    }}
                >
                    <Typography variant="subtitle1" fontWeight={600} mb={2}>
                        Create New Announcement
                    </Typography>

                    <Stack spacing={3}>
                        {/* Title */}
                        <Box>
                            <Typography variant="body2" fontWeight={500} mb={0.5}>
                                Title
                            </Typography>
                            <TextField
                                fullWidth
                                size="small"
                                value={title}
                                onChange={(e) => {
                                    setTitle(e.target.value);
                                    setErrors((prev) => ({ ...prev, title: "" })); // clear on typing
                                }}
                                placeholder="Enter title"
                                error={!!errors.title}
                                helperText={errors.title}
                            />

                        </Box>

                        {/* Content */}
                        <Box>
                            <Typography variant="body2" fontWeight={500} mb={0.5}>
                                Content
                            </Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                size="small"
                                value={content}
                                onChange={(e) => {
                                    setContent(e.target.value);
                                    setErrors((prev) => ({ ...prev, content: "" }));
                                }}
                                placeholder="Announcement details..."
                                error={!!errors.content}
                                helperText={errors.content}
                            />
                        </Box>

                        {/* Type + Parent Vendor */}
                        <Box sx={{ display: "flex", gap: 2 }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="body2" fontWeight={500} mb={0.5}>
                                    Type
                                </Typography>
                                <Select fullWidth size="small" value={type} onChange={(e) => setType(e.target.value)}>
                                    <MenuItem value="General">General</MenuItem>
                                    <MenuItem value="Supplier Specific">Supplier Specific</MenuItem>
                                    <MenuItem value="Plant Specific">Plant Specific</MenuItem>
                                </Select>
                            </Box>

                            <Box sx={{ flex: 1 }}>
                                {isSupplierSpecific && <><Typography variant="body2" fontWeight={500} mb={0.5}>
                                    Parent Vendor
                                </Typography>
                                    <NewGroupedMultiDropdown
                                        options={parentOptions}
                                        selectedItemsData={selectedParents}
                                        onChangeItems={(name, items) => handleParentVendorChange(items)}
                                        label="Parent Vendor"
                                    />

                                </>}
                                {isPlannerSpecific && <><Typography variant="body2" fontWeight={500} mb={0.5}>
                                    Select Plant
                                </Typography>
                                    <MultiDropdown
                                        options={plantsDropdownOptions?.filter(Boolean) ?? []}
                                        selectedItemsData={selectedPlants}
                                        disabled={type !== "Plant Specific"}
                                        onChangeItems={(name, items) => setSelectedPlants(items)}
                                        copyPasteDisabled={false}

                                    />

                                </>}
                            </Box>
                        </Box>

                        {/* Child Vendor */}
                        <Box sx={{ display: "flex", gap: 2 }}>
                            {isSupplierSpecific && <Box sx={{ flex: 1 }}>
                                <Typography variant="body2" fontWeight={500} mb={0.5}>
                                    Child Vendor
                                </Typography>
                                <GroupedSupplierDropdown
                                    options={filterSuppliers}
                                    selectedItems={selectedChildren}
                                    disabled={type !== "Supplier Specific"}
                                    onChangeItems={(name, items) => handleChildVendorChange(items)}
                                />

                            </Box>}
                            <Box sx={{ flex: 1 }}></Box>
                        </Box>

                        {/* Upload Document */}
                        <Box sx={{ width: "50%" }}>
                            <Typography variant="body2" fontWeight={500} mb={0.5}>
                                Upload Document
                            </Typography>

                            <TextField
                                key={fileInputKey}
                                fullWidth
                                size="small"
                                type="file"
                                // inputProps={{
                                //     accept:
                                //         ".pdf,.xls,.xlsx,.doc,.docx,.png,.jpg,.jpeg,.csv,.txt"
                                // }}
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    setUploadedFile(file);
                                }}
                            />

                            {uploadedFile && (
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: "green",
                                        mt: 1,
                                        display: "block"
                                    }}
                                >
                                    Selected File: {uploadedFile.name}
                                </Typography>
                            )}
                        </Box>
                        {/* Button */}
                        <Box textAlign="right">
                            <ButtonComponent
                                type="secondary"
                                maxWidth="200px"
                                label={loading ? "Posting..." : "Post Announcement"}
                                height="40px"
                                onClick={handleSubmit}
                                disabled={loading}
                            />
                        </Box>
                    </Stack>
                </Card>
                <Card
                    sx={{
                        mt: 3,
                        borderRadius: 2,
                        boxShadow: 1,
                        p: 2,
                    }}
                >
                    <Typography variant="subtitle1" fontWeight={600} mb={2}>
                        Existing Announcements
                    </Typography>

                    <Box sx={{ overflowX: "auto" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr style={{ background: "#f1f5f9", textAlign: "left" }}>
                                    <th style={thStyle}>Date</th>
                                    <th style={thStyle}>Title</th>
                                    <th style={thStyle}>Type</th>
                                    <th style={thStyle}>Target</th>
                                    <th style={thStyle}>Posted By</th>
                                    <th style={thStyle}>Action</th>

                                </tr>
                            </thead>
                            <tbody>
                                {announcements.length === 0 ? (
                                    <tr>
                                        <td colSpan={5} style={{ textAlign: "center", padding: 20 }}>
                                            No announcements yet
                                        </td>
                                    </tr>
                                ) : (
                                    announcements.map((item) => (
                                        <tr key={item.id} style={{ borderTop: "1px solid #e5e7eb" }}>
                                            <td style={tdStyle}>{new Date(item.createdAt).toISOString().split("T")[0]}</td>
                                            <td style={tdStyle}>{item.title}</td>
                                            <td style={tdStyle}>
                                                <Box
                                                    sx={{
                                                        display: "inline-block",
                                                        px: 2,
                                                        py: 0.5,
                                                        borderRadius: "12px",
                                                        fontSize: "13px",
                                                        fontWeight: 500,
                                                        color: item.type === "General" ? "#166534" : "#1e40af", // text color
                                                        backgroundColor: item.type === "General" ? "#dcfce7" : "#dbeafe", // light green / dark green
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {item.announcementType}
                                                </Box>
                                            </td>

                                            <td style={tdStyle}>{item.announcementType}</td>
                                            <td style={tdStyle}>{item.createdBy}</td>
                                            {/* <td style={tdStyle}>
                                                <Box sx={{ display: "flex", gap: 1 }}>
                                                    <IconButton
                                                        size="small"
                                                        sx={{
                                                            color: "#2563eb", // blue
                                                            "&:hover": { backgroundColor: "rgba(37, 99, 235, 0.1)" },
                                                        }}
                                                        onClick={() => handleEdit(item)}
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>

                                                    <IconButton
                                                        size="small"
                                                        sx={{
                                                            color: "#ef4444", // red
                                                            "&:hover": { backgroundColor: "rgba(239, 68, 68, 0.1)" },
                                                        }}
                                                        onClick={() => handleDelete(item.id)}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            </td> */}
                                            <td style={tdStyle}>
                                                <Box sx={{ display: "flex", gap: 1 }}>
                                                    <Typography
                                                        sx={{
                                                            color: "#2563eb",
                                                            cursor: "pointer",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            "&:hover": {
                                                                // textDecoration: "underline",
                                                            },
                                                        }}
                                                        onClick={() => handleView(item.announcementId)}
                                                    >
                                                        View
                                                    </Typography>
                                                </Box>
                                            </td>


                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </Box>
                </Card>
                <Dialog
                    open={openViewPopup}
                    onClose={() => setOpenViewPopup(false)}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle>
                        Announcement Details
                    </DialogTitle>

                    <DialogContent dividers>
                        <Stack spacing={2} mt={1}>
                            <TextField
                                label="Title"
                                value={viewData?.title || ""}
                                fullWidth
                                size="small"
                                sx={viewFieldStyle}
                                InputProps={{
                                    readOnly: true,
                                    sx: { color: "#000" },
                                }}
                            />

                            <TextField
                                label="Content"
                                sx={viewFieldStyle}
                                value={viewData?.content || ""}
                                fullWidth
                                multiline
                                rows={4}
                                size="small"
                                InputProps={{
                                    readOnly: true,
                                    sx: { color: "#000" },
                                }}
                            />

                            <TextField
                                label="Type"
                                sx={viewFieldStyle}
                                value={viewData?.announcementType || ""}
                                fullWidth
                                size="small"
                                InputProps={{
                                    readOnly: true,
                                    sx: { color: "#000" },
                                }}
                            />

                            {/* Parent Vendor */}
                            <TextField
                                label="Parent Vendor"
                                sx={viewFieldStyle}
                                value={viewData?.parentVendor || "N/A"}
                                fullWidth
                                size="small"
                                InputProps={{
                                    readOnly: true,
                                    sx: { color: "#000" },
                                }}
                            />

                            {/* Child Vendor */}
                            <TextField
                                label="Child Vendor"
                                sx={viewFieldStyle}
                                value={viewData?.childVendor || "N/A"}
                                fullWidth
                                size="small"
                                InputProps={{
                                    readOnly: true,
                                    sx: { color: "#000" },
                                }}
                            />

                            <TextField
                                label="Target"
                                sx={viewFieldStyle}
                                value={viewData?.target || ""}
                                fullWidth
                                size="small"
                                InputProps={{
                                    readOnly: true,
                                    sx: { color: "#000" },
                                }}
                            />

                            <TextField
                                label="Posted By"
                                sx={viewFieldStyle}
                                value={viewData?.createdBy || ""}
                                fullWidth
                                size="small"
                                InputProps={{
                                    readOnly: true,
                                    sx: { color: "#000" },
                                }}
                            />

                            <TextField
                                label="Date"
                                sx={viewFieldStyle}
                                value={viewData?.createdAt}
                                // value={new Date(viewData?.createdAt).toISOString().split("T")[0] || ""}
                                fullWidth
                                size="small"
                                InputProps={{
                                    readOnly: true,
                                    sx: { color: "#000" },
                                }}
                            />

                            {/* Uploaded Document */}
                            <Box>
                                <Typography
                                    variant="body2"
                                    fontWeight={500}
                                    mb={1}
                                >
                                    Uploaded Document
                                </Typography>

                                {viewData?.attachmentUrl ? (
                                    <Box
                                        sx={{
                                            border: "1px solid #d1d5db",
                                            borderRadius: "8px",
                                            p: 2,
                                            backgroundColor: "#f9fafb",
                                        }}
                                    >
                                        <Typography
                                            component="a"
                                            href={viewData.attachmentUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                color: "#2563eb",
                                                textDecoration: "underline",
                                                cursor: "pointer",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                wordBreak: "break-all",
                                            }}
                                        >
                                            Open Uploaded Document
                                        </Typography>
                                    </Box>
                                ) : (
                                    <Typography
                                        sx={{
                                            color: "#6b7280",
                                            fontSize: "14px",
                                        }}
                                    >
                                        No Document Uploaded
                                    </Typography>
                                )}
                            </Box>
                        </Stack>
                    </DialogContent>

                    <DialogActions>
                        <ButtonComponent
                            type="secondary"
                            label="Close"
                            onClick={() => setOpenViewPopup(false)}
                        />
                    </DialogActions>
                </Dialog>
            </div>
        </>
    );
};

export default AdminAnnouncements;
